import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { cn } from "helpers/style";
import styles from "./ProgressBar.module.scss";

const ProgressBar: React.FC = () => {
  const [percent, setPercent] = useState(0);
  const timeoutRef = useRef(null);
  const router = useRouter();

  function onStart() {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    setPercent(0);
    timeoutRef.current = setTimeout(() => {
      setPercent(75);
    });
  }

  function onComplete() {
    setPercent(100);

    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setPercent(0);
    }, 1000);
  }

  useEffect(() => {
    router.events.on("routeChangeStart", onStart);
    router.events.on("routeChangeComplete", onComplete);
    router.events.on("routeChangeError", onComplete);

    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      router.events.off("routeChangeStart", onStart);
      router.events.off("routeChangeComplete", onComplete);
      router.events.off("routeChangeError", onComplete);
    };
  }, []);

  return (
    <div
      className={cn([styles.progressBar, percent && styles.progressBarEnable])}
    >
      <div
        className={cn([
          styles.progressBarInner,
          percent && styles.progressBarInnerEnable,
        ])}
        style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
      />
    </div>
  );
};

export default ProgressBar;
